import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import PropTypes from 'prop-types';

import Badge from '../common/badge';

import { safeExtractFromObject } from '../helpers/helpers';

import { BADGE_STYLE } from './menu.constants';

function OntraccrSubMenu({
  key,
  text,
  Icon,
  children,
  badgeCount,
  ...rest
}) {
  const isMenuOpen = useSelector((state) => state.menu.isMenuOpen);
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const hasRedesign = settings?.uxRedesignPt1;

  let menuItemClass = hasRedesign ? 'submenu-item-redesign' : null;
  const containerClass = hasRedesign ? 'submenu-item-container' : null;
  const textClass = hasRedesign ? 'menu-item-text-redesign' : null;
  const iconClass = hasRedesign ? 'menu-icon-redesign' : null;
  const badgeTop = hasRedesign ? 12 : '0.2em';

  if (!isMenuOpen) {
    menuItemClass += ' submenu-item-redesign-closed';
  }

  const itemStyle = hasRedesign
    ? { paddingLeft: 0, paddingRight: 0, transform: 'translateX(-24px)' }
    : {};

  return (
    <Menu.SubMenu
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      key={key}
      className={menuItemClass}
      style={itemStyle}
      title={(
        <div className={containerClass}>
          <Icon className={iconClass} />
          { isMenuOpen && <span className={textClass}>{text}</span> }
          {badgeCount && isMenuOpen
            ? <Badge count={badgeCount} style={{ ...BADGE_STYLE, top: badgeTop }} />
            : null}
        </div>
      )}
      popupClassName={hasRedesign && !isMenuOpen ? 'ontraccr-sub-menu' : null}
    >
      {children}
    </Menu.SubMenu>
  );
}

OntraccrSubMenu.propTypes = {
  key: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  Icon: PropTypes.node.isRequired,
  badgeCount: PropTypes.number,
  children: PropTypes.node.isRequired,
};

OntraccrSubMenu.defaultProps = {
  badgeCount: 0,
};

export default OntraccrSubMenu;
